import env from "./env";

// Backend Server API Endpoints
// ## Production
// const SERVER_BASE_URL = "https://apichaseleads.edgenroots.org"
// const SERVER_BASE_URL = "https://apiprod.banquetfirst.com"
// const SERVER_BASE_URL = "https://prodapi.talkvit.com"

// ## Preprod
// const SERVER_BASE_URL = "https://api.preview.banquetfirst.com" // main 
// const SERVER_BASE_URL = "https://chaseapi.preview.banquetfirst.com" // Chaseleads

// ## User Specific
// const SERVER_BASE_URL = "https://7d0f5c31-5001.inc1.devtunnels.ms" //Krishna
// const SERVER_BASE_URL = "https://t5pq9lll-5001.inc1.devtunnels.ms" //Vivek

// ## Feature Branch
// const SERVER_BASE_URL = "https://2193apifeature.preview.banquetfirst.com" // Import Menu
// const SERVER_BASE_URL = "https://2250apifeature.preview.banquetfirst.com" //Filter


export const apiConfig = Object.freeze({
  baseUrl: `${env.SERVER_BASE_URL}/api/v1`,
  socketUrl: env.SERVER_BASE_URL,

  // baseUrl: `${SERVER_BASE_URL}/api/v1`,
  // socketUrl: SERVER_BASE_URL,
});
